<template>
    <div>
        <h2 class="headline">Smitta</h2>

        <form @submit.prevent id="alertInformation-details" autocomplete="off">
            <div class="form-group k3-form fullscreen">
                <!-- Vissa fält döljs (utkommenteras)  tills vidare -->
                <input-wrapper
                    v-if="!fieldsDeactivated"
                    :colspan="8"
                    :disabled="false"
                    :component="widgets.DateWidget"
                    name="ascertainedDate"
                    v-model="form.ascertainedDate"
                    label="Fastställandedatum"
                />
                <input-wrapper
                    v-if="!fieldsDeactivated"
                    :disabled="false"
                    :colspan="8"
                    name="verifiedTime"
                    v-model="form.verifiedTime"
                    :component="widgets.DateWidget"
                    label="Verifierat datum"
                />
                <div class="colspan c8">
                    <h4>Giltighetstid</h4>
                </div>
                <input-wrapper
                    :disabled="false"
                    :colspan="3"
                    name="validityTimePeriodStart"
                    v-model="form.validityTimePeriodStart"
                    required="true"
                    :component="widgets.DateWidget"
                    label="Från"
                />
                <input-wrapper
                    :disabled="false"
                    name="validityTimePeriodEnd"
                    v-model="form.validityTimePeriodEnd"
                    :component="widgets.DateWidget"
                    :colspan="3"
                    label="Till"
                />
                <input-wrapper
                    :disabled="false"
                    name="comment"
                    v-model="form.comment"
                    :maxlength="140"
                    :required="true"
                    :colspan="8"
                    :component="widgets.TextAreaWidget"
                    label="Kommentar"
                />
                <input-wrapper
                    :component="widgets.InfiniteWidget"
                    name="code"
                    :displayCode="true"
                    v-model="form.code"
                    apisearch="/core/kodverk/icdkoder/"
                    :colspan="8"
                    label="ICD-kod"
                />
                <input-wrapper
                    name="routeOfTransmission"
                    v-model="form.routeOfTransmission"
                    apisearch="/uppmarksamhetssignal/rotc/"
                    :colspan="8"
                    :component="widgets.SelectWidget"
                    label="Smittväg"
                />
            </div>
            <ButtonGroup>
                <Button type="button" @click="sign" size="primary">
                    <img src="@/assets/sign_white.svg" />Signera
                </Button>
                <Button @click="save" type="button" size="primary">
                    <img src="@/assets/send_white.svg" />Spara uppmärksamhetssignal
                </Button>
                <Button type="button" @click="cancel" variant="contour" size="secondary">Avbryt</Button>
            </ButtonGroup>
        </form>
    </div>
</template>

<script>
    import widgets from "@/components/widgets/inputs";
    import InputWrapper from "@/components/widgets/inputs/InputWrapper.vue";
    import Button from "@/components/Button.vue";
    import ButtonGroup from "@/components/ButtonGroup.vue";
    import { isEqual } from "lodash";

    const createDefaultForm = () => ({
        ascertainedDate: null,
        verifiedTime: null,
        validityTimePeriodStart: new Date().toLocaleDateString("sv-SE"),
        validityTimePeriodEnd: null,
        comment: "",
        code: "",
        routeOfTransmission: null,
        type: "cd",
    });

    export default {
        name: "communicableForm",
        props: ["chosenComponent", "alertInformationForm"],
        components: {
            ButtonGroup,
            Button,
            InputWrapper,
        },
        data() {
            return {
                form: createDefaultForm(),
                widgets: widgets,
                fieldsDeactivated: true,
            };
        },
        computed: {
            hasUnsavedData() {
                return !isEqual(createDefaultForm(), this.form);
            },
        },
        watch: {
            hasUnsavedData(value) {
                this.$emit("hasUnsavedData", value);
            },
        },
        methods: {
            cancel() {
                this.$emit("cancelAlertForm");
            },
            save() {
                if (!this.validateForm("alertInformation-details")) {
                    return;
                }

                if (this.form.validityTimePeriodEnd === "") {
                    this.form.validityTimePeriodEnd = null;
                }
                this.$emit("save", this.form);
            },
            sign() {
                if (!this.validateForm("alertInformation-details")) {
                    return;
                }
                if (this.form.validityTimePeriodEnd === "") {
                    this.form.validityTimePeriodEnd = null;
                }
                this.$emit("sign", this.form);
            },
            validateForm(formName) {
                const form = document.getElementById(formName);

                if (form.checkValidity() === true) return true;
                else {
                    const list = form.querySelectorAll(":invalid");
                    for (let item of list) {
                        item.focus();
                        item.blur();
                    }
                    form.querySelector(":invalid").focus();
                }
                return false;
            },
        },
    };
</script>

<style lang="sass" scoped>
    #alertInformation-details
        position: relative
        min-height: 600px
        min-width: 600px
        display: inline-block


    h2
        margin: 10px 0px 10px 0px !important

    .radiobutton-line
        display: inline-block
        margin-top: 12px
        margin-bottom: 30px

        label:not(:first-of-type)
            margin-left: 32px

    .btn-group
        float: none !important

    .headline
        margin-bottom: 20px !important
</style>
